import React from 'react';
import './App.css';
import { Content, Footer } from './components';
import Logo from './Hero_Title.svg';

function App() {
  return (
    <div className="App">
      <div className="Hero"> <img className='Logo_Title' alt='Notero Piano Adventure Logo' src={Logo} /> </div>
      <div className="Content_Container">
        <Content />
      </div>
      <Footer />
    </div>
  );
}

export default App;
